<template>
  <div class="particles-js" :id="id">
  </div>
</template>
<script>
  import ParticlesJSON from './config.js/particlesjs-config.json'
  /* eslint-disable */
  export default {
    name: 'vue-particles',
    data () {
      return {
        id: 'particles'
      }
    },
    mounted () {
      require('particles.js')
      this.$nextTick(() => {
        this.initParticleJS(
          this.color,
          this.particleOpacity,
          this.particlesNumber,
          this.shapeType,
          this.particleSize,
          this.linesColor,
          this.linesWidth,
          this.lineLinked,
          this.lineOpacity,
          this.linesDistance,
          this.moveSpeed,
          this.hoverEffect,
          this.hoverMode,
          this.clickEffect,
          this.clickMode
        )
      })
    },
    methods: {
      initParticleJS () {
        particlesJS(this.id, ParticlesJSON);
      }
    }
  }
  /* eslint-disable */
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.particles-js{
    background: linear-gradient(180deg,#2d598b,#0b1623);
    position: absolute;
	  z-index: -1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    min-height: 768px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Particles.vue